import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['Dealer'],
});
export const dealerApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllDealers: builder.query({
      query: () => `dealers/`,
      providesTags: ['Dealer'],
    }),
    findAllDealersWithLocation: builder.query({
      query: () => `dealers/?location_master__isnull=False`,
      providesTags: ['Dealer'],
    }),
    findAllDealersOfCluster: builder.query({
      query: (id) => `dealers/?cluster=${id}`,
      providesTags: ['Dealer'],
    }),
    findDealerById: builder.query({
      query: (id) => `dealers/${id}/`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'Dealer', id: result.id }] : ['Dealer'];
      },
    }),
    createDealer: builder.mutation({
      query: (dealer) => ({
        url: `dealers/`,
        method: 'POST',
        body: dealer,
      }),
      invalidatesTags: ['Dealer'],
    }),
    updateDealer: builder.mutation({
      query: (dealer) => ({
        url: `dealers/${dealer.id}/`,
        method: 'PATCH',
        body: dealer,
      }),
      invalidatesTags: ['Dealer'],
    }),
    updateDealerLocation: builder.mutation({
      query: ({ id, payload }) => ({
        url: `dealers/${id}/insertLocation/`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Dealer'],
    }),
    deleteDealer: builder.mutation({
      query: (dealer) => ({
        url: `dealers/${dealer.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Dealer'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllDealersQuery,
  useFindAllDealersWithLocationQuery,
  useFindDealerByIdQuery,
  useCreateDealerMutation,
  useUpdateDealerMutation,
  useDeleteDealerMutation,
} = dealerApi;
